var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFoundWorks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 273.405,
    height: 313.182,
    viewBox: "0 0 273.405 313.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2216",
    "data-name": "Rectangle 2216",
    width: 240.339,
    height: 286.024,
    transform: "translate(-6 -4)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2217",
    "data-name": "Rectangle 2217",
    width: 223.339,
    height: 276.024,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1698",
    "data-name": "Group 1698",
    transform: "translate(6.443 32.529) rotate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1695",
    "data-name": "Group 1695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1694",
    "data-name": "Group 1694",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4848",
    "data-name": "Path 4848",
    d: "M24.788,274.759l187.891-10.077a9.942,9.942,0,0,0,9.4-10.46L209.012,10.661a9.942,9.942,0,0,0-10.46-9.4L10.661,11.342a9.942,9.942,0,0,0-9.4,10.46L14.328,265.364a9.942,9.942,0,0,0,10.46,9.395",
    fill: "#e4e4e4",
    stroke: "#231f20",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4849",
    "data-name": "Path 4849",
    d: "M24.788,274.759l187.891-10.077a9.942,9.942,0,0,0,9.4-10.46L209.012,10.661a9.942,9.942,0,0,0-10.46-9.4L10.661,11.342a9.942,9.942,0,0,0-9.4,10.46L14.328,265.364A9.942,9.942,0,0,0,24.788,274.759Z",
    fill: "none",
    stroke: "#e4e4e4",
    strokeWidth: 2.501
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5736",
    "data-name": "Path 5736",
    d: "M.7,0H6.842V-13.811l-.19-4.245h.38L9.756,0H18.15V-29.142H12.005v13.811l.19,4.245h-.412L9.059-29.142H.7ZM27.051-29.427c-4.561,0-7.507,1.679-7.507,6.62V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62V-22.807C34.559-27.748,31.581-29.427,27.051-29.427Zm.824,6.652V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-22.775c0-.824.348-1.077.824-1.077C27.495-23.852,27.875-23.6,27.875-22.775Zm21.7-6.367H35.382v5.575h3.769V0H45.8V-23.567h3.769ZM66.8-23.567v-5.575H55.972V0h6.715V-11.593H66.8v-5.512H62.687v-6.462Zm8.9-5.86c-4.561,0-7.507,1.679-7.507,6.62V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62V-22.807C83.213-27.748,80.236-29.427,75.706-29.427Zm.824,6.652V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-22.775c0-.824.348-1.077.824-1.077C76.149-23.852,76.529-23.6,76.529-22.775Zm23.092-6.367H92.938V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-29.142H84.607V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62ZM101.015,0h6.145V-13.811l-.19-4.245h.38L110.074,0h8.394V-29.142h-6.145v13.811l.19,4.245H112.1l-2.724-18.055h-8.362Zm27.748-29.142h-8.9V0h8.9c5.036,0,6.113-1.774,6.113-6.62v-15.9C134.877-27.368,133.8-29.142,128.763-29.142Zm-.57,22.427c0,.824-.222,1.14-1.014,1.14h-.634V-23.567h.634c.792,0,1.014.317,1.014,1.14Z",
    transform: "translate(39.938 68.988) rotate(-3.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M.7,0H6.842V-13.811l-.19-4.245h.38L9.756,0H18.15V-29.142H12.005v13.811l.19,4.245h-.412L9.059-29.142H.7ZM27.051-29.427c-4.561,0-7.507,1.679-7.507,6.62V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62V-22.807C34.559-27.748,31.581-29.427,27.051-29.427Zm.824,6.652V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-22.775c0-.824.348-1.077.824-1.077C27.495-23.852,27.875-23.6,27.875-22.775Zm21.7-6.367H35.382v5.575h3.769V0H45.8V-23.567h3.769ZM66.8-23.567v-5.575H55.972V0h6.715V-11.593H66.8v-5.512H62.687v-6.462Zm8.9-5.86c-4.561,0-7.507,1.679-7.507,6.62V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62V-22.807C83.213-27.748,80.236-29.427,75.706-29.427Zm.824,6.652V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-22.775c0-.824.348-1.077.824-1.077C76.149-23.852,76.529-23.6,76.529-22.775Zm23.092-6.367H92.938V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-29.142H84.607V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62ZM101.015,0h6.145V-13.811l-.19-4.245h.38L110.074,0h8.394V-29.142h-6.145v13.811l.19,4.245H112.1l-2.724-18.055h-8.362Zm27.748-29.142h-8.9V0h8.9c5.036,0,6.113-1.774,6.113-6.62v-15.9C134.877-27.368,133.8-29.142,128.763-29.142Zm-.57,22.427c0,.824-.222,1.14-1.014,1.14h-.634V-23.567h.634c.792,0,1.014.317,1.014,1.14Z",
    transform: "translate(41.815 103.984) rotate(-3.07)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M.7,0H6.842V-13.811l-.19-4.245h.38L9.756,0H18.15V-29.142H12.005v13.811l.19,4.245h-.412L9.059-29.142H.7ZM27.051-29.427c-4.561,0-7.507,1.679-7.507,6.62V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62V-22.807C34.559-27.748,31.581-29.427,27.051-29.427Zm.824,6.652V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-22.775c0-.824.348-1.077.824-1.077C27.495-23.852,27.875-23.6,27.875-22.775Zm21.7-6.367H35.382v5.575h3.769V0H45.8V-23.567h3.769ZM66.8-23.567v-5.575H55.972V0h6.715V-11.593H66.8v-5.512H62.687v-6.462Zm8.9-5.86c-4.561,0-7.507,1.679-7.507,6.62V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62V-22.807C83.213-27.748,80.236-29.427,75.706-29.427Zm.824,6.652V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-22.775c0-.824.348-1.077.824-1.077C76.149-23.852,76.529-23.6,76.529-22.775Zm23.092-6.367H92.938V-6.367c0,.824-.38,1.077-.824,1.077-.475,0-.824-.253-.824-1.077V-29.142H84.607V-6.335c0,4.941,2.946,6.62,7.507,6.62,4.53,0,7.507-1.679,7.507-6.62ZM101.015,0h6.145V-13.811l-.19-4.245h.38L110.074,0h8.394V-29.142h-6.145v13.811l.19,4.245H112.1l-2.724-18.055h-8.362Zm27.748-29.142h-8.9V0h8.9c5.036,0,6.113-1.774,6.113-6.62v-15.9C134.877-27.368,133.8-29.142,128.763-29.142Zm-.57,22.427c0,.824-.222,1.14-1.014,1.14h-.634V-23.567h.634c.792,0,1.014.317,1.014,1.14Z",
    transform: "translate(43.692 138.981) rotate(-3.07)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1697",
    "data-name": "Group 1697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1696",
    "data-name": "Group 1696",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M187.054,238.955l5.825,2.695-5.412,3.45-2.7,5.825-3.45-5.412-5.825-2.7,5.412-3.45,2.695-5.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4851",
    "data-name": "Path 4851",
    d: "M33.745,179.922l5.825,2.7-5.412,3.45-2.695,5.825-3.45-5.412-5.825-2.695,5.412-3.45,2.695-5.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4852",
    "data-name": "Path 4852",
    d: "M204.941,222.816l3.153,1.628-3.071,1.777-1.628,3.153-1.777-3.072-3.154-1.627,3.072-1.777,1.628-3.154Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    "data-name": "Group 1861",
    transform: "matrix(0.927, -0.375, 0.375, 0.927, -863.626, 216.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M1.779,72.544A58.294,58.294,0,1,0,44.073,1.779,58.294,58.294,0,0,0,1.779,72.544",
    transform: "matrix(0.946, 0.326, -0.326, 0.946, 885.98, 253.506)",
    fill: "#d9ff50"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 58.294,
    cy: 58.294,
    rx: 58.294,
    ry: 58.294,
    transform: "translate(837.844 330.812) rotate(-43)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5731",
    "data-name": "Path 5731",
    d: "M.246,43.112C-.316,48.38,5.971,47.987,9.9,49.559c-3.537-16.5-.786-33.4,4.323-49.515C-.316-1.134,1.255,21.658.032,31.837c-.091,3.741.02,7.517.214,11.276",
    transform: "matrix(0.946, 0.326, -0.326, 0.946, 919.028, 286.188)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M4.148,38.592c1.374,3.157,5.617,4.234,8.765,3.758,5.607-.848.879-5.436-.3-9.1a38.552,38.552,0,0,1-1.672-11.79c0-4.531,1.4-9.362,1.858-14.029.15-1.511,1.121-4.9.244-6.237C9.548-4.124,1.442,9.925.866,12.335-1.2,20.983.651,30.558,4.148,38.592",
    transform: "matrix(0.946, 0.326, -0.326, 0.946, 931.536, 302.822)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M66.137,10.015C62.914,4.513,57.4-1.846,50.533.5,45.049,2.13,41.776,6.652,37.942,10.765c-7.878,8.509-18.066,4.149-27.384,2.147C5.131,11.785.924,16.706,0,21.619",
    transform: "matrix(0.94, 0.342, -0.342, 0.94, 890.02, 338.515)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5734",
    "data-name": "Path 5734",
    d: "M5.63,1.017A3.268,3.268,0,0,0,2.052.232,3.332,3.332,0,0,0,0,3.318",
    transform: "matrix(0.94, 0.342, -0.342, 0.94, 947.032, 369.57)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M0,1.337A2.652,2.652,0,0,1,3.256.177,4.679,4.679,0,0,1,6.243,3.016",
    transform: "matrix(0.94, 0.342, -0.342, 0.94, 879.207, 357.296)",
    fill: "none",
    stroke: "#231f20",
    strokeWidth: 2
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundWorks);
export default __webpack_public_path__ + "static/media/not-found-works.b2df704de733239474b5f37d1b220571.svg";
export { ForwardRef as ReactComponent };